import { ContactProps } from '@/models/Contact';
import { USCountryId } from '@/utils/constants';

export function isFullAddress(contact: ContactProps): boolean {
  const isUS = contact.countryId === USCountryId;
  if (!contact.countryId) return false;

  if (!isUS) {
    return !!(contact.streetAddress1 && contact.city && contact.zipCode);
  }

  return !!(
    contact.streetAddress1 &&
    contact.city &&
    contact.stateId &&
    contact.countyId &&
    contact.zipCode
  );
}
